var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollaborateIcon = function SvgCollaborateIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#F6D4BE",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F8741C",
    fillRule: "evenodd",
    d: "M20 14.167a3.333 3.333 0 1 0 0 6.667 3.333 3.333 0 0 0 0-6.667M18.333 17.5a1.667 1.667 0 1 1 3.334 0 1.667 1.667 0 0 1-3.334 0M20 28.334c-.948 0-2.314-.224-3.35-.7-.509-.234-1.054-.581-1.376-1.1A1.77 1.77 0 0 1 15 25.58c.003-.356.115-.693.298-1.003.835-1.413 2.568-2.909 4.702-2.909s3.867 1.496 4.702 2.91c.183.309.294.646.298 1.002.003.359-.104.682-.274.955-.322.519-.867.866-1.376 1.1-1.037.476-2.403.7-3.35.7m-3.267-2.91c-.064.108-.066.162-.067.171 0 .006 0 .023.024.06.066.107.258.281.656.464.775.356 1.895.548 2.654.548.76 0 1.878-.192 2.654-.548.398-.183.59-.357.656-.463.024-.038.023-.054.023-.06 0-.01-.002-.064-.066-.172-.648-1.096-1.914-2.09-3.267-2.09s-2.62.994-3.267 2.09",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8741C",
    fillRule: "evenodd",
    d: "M12.083 20a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m2.5-.833a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8741C",
    d: "M12.413 26.204a.833.833 0 0 1-1.493-.74 5.2 5.2 0 0 1 1.353-1.71c.583-.475 1.33-.837 2.183-.837a.833.833 0 1 1 0 1.667c-.368 0-.755.156-1.132.463a3.6 3.6 0 0 0-.911 1.157"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8741C",
    fillRule: "evenodd",
    d: "M23.175 20a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m2.5-.833a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8741C",
    d: "M29.083 25.463a.833.833 0 0 1-1.493.741 3.6 3.6 0 0 0-.91-1.157c-.377-.307-.765-.463-1.133-.463a.833.833 0 0 1 0-1.667c.853 0 1.6.362 2.184.836a5.2 5.2 0 0 1 1.352 1.71"
  })));
};
export default SvgCollaborateIcon;